var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatMute({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.189,
    height: 16.006,
    viewBox: "0 0 18.189 16.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-39.841 19.776)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.841 -19.776)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.5 5.585)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#26B963",
    d: "M365.018,204.271l1.544-1.544a.469.469,0,1,0-.663-.663l-1.544,1.544-1.544-1.544a.469.469,0,1,0-.663.663l1.544,1.544-1.544,1.544a.469.469,0,1,0,.663.663l1.544-1.544,1.544,1.544a.469.469,0,1,0,.663-.663Z",
    transform: "translate(-362.011 -201.927)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#26B963",
    d: "M11.689.139a1.394,1.394,0,0,0-1.5.193L4.05,3.63H1.407A1.408,1.408,0,0,0,0,5.037v5.939a1.408,1.408,0,0,0,1.407,1.407H4.05l6.141,3.3A1.407,1.407,0,0,0,12.5,14.6V1.413A1.394,1.394,0,0,0,11.689.139ZM3.751,11.451H1.407a.475.475,0,0,1-.469-.475V5.037a.469.469,0,0,1,.469-.469H3.751v6.883Zm7.81,3.149a.469.469,0,0,1-.769.36l-6.1-3.267V4.319l6.1-3.267a.469.469,0,0,1,.769.36Z",
    transform: "translate(0 -0.004)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMute);
export default __webpack_public_path__ + "static/media/chatMute.36ddb1d2f20ace2ae88a8da04efbf692.svg";
export { ForwardRef as ReactComponent };